import React, { useCallback, useState } from "react"
import PropTypes from "prop-types"
import { Button, Col, CustomInput, Form, FormGroup, Input, Label, Row, UncontrolledAlert } from "reactstrap"
import TastyButton from "components/TastyButton"
import tastyworksApi from "utils/tastyworksApi"

const propTypes = {
  onForgotPasswordClick: PropTypes.func.isRequired
};

function LoginForm({ onForgotPasswordClick }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [rememberMe, setRememberMe] = useState(false);
  const [apiError, setApiError] = useState(null);
  const [apiPending, setApiPending] = useState(false);

  const handleSubmit = useCallback(
    async (event) => {
      event.preventDefault();

      setApiPending(true);
      setApiError(null);

      try {
        await tastyworksApi.login(username, password, rememberMe);

        setApiPending(false);

        tastyworksApi.loginSuccessRedirect();
      } catch (error) {
        setApiError(error.message);
        setApiPending(false);

        return error;
      }
    },
    [username, password],
  );

  return (
    <Form onSubmit={handleSubmit}>
      {apiError && (
        <UncontrolledAlert color='danger' className='small'>{apiError}</UncontrolledAlert>
      )}
      <FormGroup>
        <Label for='username' size='sm'>
          Username/Email
        </Label>
        <Input
          type='text'
          name='text'
          id='username'
          value={username}
          onChange={e => setUsername(e.target.value)}
          required
        />
      </FormGroup>
      <FormGroup>
        <Label for='password' size='sm'>
          Password
        </Label>
        <Input
          type='password'
          name='password'
          id='password'
          value={password}
          onChange={e => setPassword(e.target.value)}
          required
        />
      </FormGroup>
      <Row>
        <Col md={12}>
          <FormGroup>
            <CustomInput
              type='checkbox'
              id='rememberMe'
              label='Remember Me'
              bsSize='sm'
              onChange={e => setRememberMe(e.target.checked)}
              checked={rememberMe}
            />
          </FormGroup>
        </Col>
        <Col md={12} className='text-right'>
          <Button
            color='link'
            size='sm'
            type='sm'
            onClick={onForgotPasswordClick}
            style={{color: '#e02529', marginBottom: '0.5rem'}}
          >
            Forgot Password?
          </Button>
        </Col>
      </Row>

      <TastyButton primary type='submit' block size='lg' disabled={apiPending}>
        Sign In
      </TastyButton>
    </Form>
  );
}

LoginForm.propTypes = propTypes;

export default LoginForm;
